"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRouteComponent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _usePropsUpdatedChildren = require("./usePropsUpdatedChildren");

var _propTypes = require("prop-types");

var _excluded = ["variation", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getRouteComponent = function getRouteComponent(map, name) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$childTypes = _ref.childTypes,
      childTypes = _ref$childTypes === void 0 ? [] : _ref$childTypes;

  var Component = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    // eslint-disable-next-line
    var variation = props.variation,
        children = props.children,
        rest = (0, _objectWithoutProperties2.default)(props, _excluded);
    var updateProps = (0, _react.useCallback)(function (oldProps) {
      return !oldProps ? {
        variation: variation
      } : _objectSpread(_objectSpread({}, oldProps), {}, {
        variation: variation
      });
    }, [variation]);
    var updatedChildren = (0, _usePropsUpdatedChildren.usePropsUpdatedChildren)(children, childTypes, updateProps);
    var Route = map[variation || 'primary'];
    return /*#__PURE__*/_react.default.createElement(Route, (0, _extends2.default)({
      ref: ref,
      children: updatedChildren
    }, rest));
  });
  Component.propTypes = {
    // eslint-disable-next-line
    variation: (0, _propTypes.oneOf)(['primary', 'secondary'])
  };
  Object.defineProperty(Component, 'name', {
    value: name
  });
  return Component;
};

exports.getRouteComponent = getRouteComponent;